document.addEventListener('DOMContentLoaded', function () {
	// HASH
	const hash = window.location.hash?.split("/");
	let orderIdFromURL = null, 
	phoneNumberFromURL = null;
	if (!Shopify.designMode){ 
		if (hash.length === 2){
			[orderIdFromURL, phoneNumberFromURL] = hash;
			if (!/^(?:\+91|91)?[6-9]\d{9}$/.test(phoneNumberFromURL)){
				window.location.replace("/");
			}
		}else{
			window.location.replace("/");
		}
	}
	const wrapperEl = document.querySelector(".nps-feedback-form__inner-wrapper");
	const submitWrapperEl = document.querySelector('.nps-feedback-form__submit-wrapper');
	const successWrapperEl = document.querySelector(".nps-feedback-form__success-wrapper ");
	const ratingItems = wrapperEl.querySelectorAll(".nps-feedback-form__rating-item input");
	const form = wrapperEl.querySelector("form");
	const submitBtnEl = form?.querySelector(".nps-feedback-form__submti-button");
	// SECTIONS
	const badSection = wrapperEl.querySelector(".nps-feedback-form__bad-pointers-wrapper[data-nps-feedback-bad]");
	const okSection = wrapperEl.querySelector(".nps-feedback-form__bad-pointers-wrapper[data-nps-feedback-ok]");
	const goodSection = wrapperEl.querySelector(".nps-feedback-form__bad-pointers-wrapper[data-nps-feedback-good]");
	// OTHER FEEDBACKS
	const otherFeedbackCheckboxes = wrapperEl.querySelectorAll('.nps-other-feedback');
	const otherFeedbackInputElList = wrapperEl.querySelectorAll('.nps-feedback-form__other-feedback-input');
	let hasOtherFeedback = false;
	let otherFeedback = '';
	// PHONE NO
	let isPhoneNumberEnabled = wrapperEl?.dataset.phoneEnabled || false;
	if (isPhoneNumberEnabled){
		isPhoneNumberEnabled = JSON.parse(isPhoneNumberEnabled);
	}
	let phoneNumber = wrapperEl?.dataset.phoneNumber || "";
	if (window.customerPhone && window.customerPhone !== "NA") {
		let cleaned = window.customerPhone.replace(/\D/g, ""); // keep only digits
		// If starts with +91 or 91 and has 12/11 digits → strip the prefix
		if (cleaned.length === 12 && cleaned.startsWith("91")) {
			cleaned = cleaned.slice(2);
		} else if (cleaned.length === 11 && cleaned.startsWith("91")) {
			cleaned = cleaned.slice(2);
		}
		// Now cleaned should be only 10 digits if valid
		if (cleaned.length === 10) {
			phoneNumber = cleaned;
		}
	}
	const phoneNumberInput = wrapperEl.querySelector('#npsFeedbackFormPhoneInput');
	const indianPhoneRegex = /^[6-9]\d{9}$/
	// PHONE NO VALIDATION
	if (!phoneNumber && phoneNumberInput) {
		 phoneNumberInput.addEventListener('input', () => {
        let cleaned = phoneNumberInput.value.replace(/\D/g, "");
        cleaned = cleaned.slice(0, 10);
        phoneNumberInput.value = cleaned;
        phoneNumber = cleaned;
        if (!indianPhoneRegex.test(cleaned)) {
            phoneNumberInput.style.color = "#bf1533";
        } else {
            phoneNumberInput.style.color = "#000";
        }
    });
	}
	const submitButton = form.querySelector("button[type='submit']");
	const commentTextarea = wrapperEl.querySelector("#npsFeedbackFormPhoneTextArea");
	const textAreaMaxLength = wrapperEl.querySelector("#npsFeedbackFormPhoneTextAreaMaxLength")

	let selectedRating = null;

	ratingItems.forEach((input, index) => {
		input.addEventListener("change", function () {

			if (form.classList.contains("tw-hidden")) {
				form.classList.remove("tw-hidden");
			}

			const label = input.closest(".nps-feedback-form__rating-item");
			selectedRating = index;

			[badSection, okSection, goodSection].forEach(el => el.style.display = "none");
			form.reset();
			// show relevant section
			let activeSection = null;
			if (label.hasAttribute("data-nps-feedback-bad")) {
				badSection.style.display = "flex";
				activeSection = badSection;
			} else if (label.hasAttribute("data-nps-feedback-ok")) {
				okSection.style.display = "flex";
				activeSection = okSection;
			} else if (label.hasAttribute("data-nps-feedback-good")) {
				goodSection.style.display = "flex";
				activeSection = goodSection;
			}

			// Show form elements
			commentTextarea.style.display = "block";
			submitButton.style.display = "block";
		});
	});

	// handle form submission with validation
	form.addEventListener("submit", function (e) {
		e.preventDefault();

		const activeSection = [badSection, okSection, goodSection].find(el => el.style.display === "flex");
		const feedbacks = [...activeSection.querySelectorAll("input[type='checkbox']:checked")]
			.map(cb => {
				if (cb.classList.contains('nps-other-feedback')) {
					otherFeedback = cb.parentElement.querySelector('.nps-feedback-form__other-feedback-input').value;
					return otherFeedback;
				}
				return cb.parentElement.textContent.trim()
			});

		// Validation
		if (!feedbacks.length) {
			alert("Please select at least one feedback option.");
			return;
		}

		if (hasOtherFeedback) {
			if (otherFeedback == "") {
				alert("Please provide the additional feedback");
				return;
			}
		}
		let comment = commentTextarea.value.trim();
		if (!comment) {
			comment = "NA"
		}
		if (isPhoneNumberEnabled){
			if (!phoneNumber) {
				alert("Phone number is required. Please update your number to continue.");
				return;
			}
			if (phoneNumber) {
				if (!/^(?:\+91|91)?[6-9]\d{9}$/.test(phoneNumber)) {
					alert("Invalid phone number. Please enter a valid Indian mobile number");
					phoneNumberInput.value = "";
					return;
				}
			}
		}

		const params = new URLSearchParams({
			orderId: orderIdFromURL || "NA",
			phone: phoneNumberFromURL || phoneNumber || "NA",
			rating: `${selectedRating}` || "0",
			feedback: feedbacks.join(", "),
			comment: comment,
		});
		
		// Google Apps Script Web App URL
		const googleSheetURL = "https://script.google.com/macros/s/AKfycbwu_me7p8q5cQmVERFaOCBSV_62mJHUM1gNHFS-YeaC4JSvuo5T403g2a2OG3ivnG98/exec";
		
		submitBtnEl.setAttribute('disabled', true);
		submitButton.textContent = "Submitting..."
		fetch(`${googleSheetURL}?${params.toString()}`, {
			method: "GET",
			headers: { "Content-Type": "application/x-www-form-urlencoded" }
		})
			.then(res => res.json())
			.then(response => {
				submitWrapperEl.classList.add("tw-hidden");
				successWrapperEl.classList.remove("tw-hidden");
				const redirectionTextSec = successWrapperEl.querySelector('.nps-feedback-from__redirection-text span');
				let seconds = 5;
				redirectionTextSec.textContent = seconds;
				const countdownTimer = setInterval(() => {
					seconds--;
					redirectionTextSec.textContent = seconds;
					if (seconds <= 0) {
						clearInterval(countdownTimer);
						window.location.replace("/");
					}
				}, 1000);
				form.reset();
				[badSection, okSection, goodSection, submitButton, commentTextarea, form].forEach(el => el.style.display = "none");
				selectedRating = null;
				submitBtnEl.setAttribute('disabled', false);
			})
			.catch(err => {
				alert("Error submitting feedback. Please try again.");
				console.error(err);
				sub.textContent = "Submit";
				submitBtnEl.setAttribute('disabled', false);
			});
	});

	otherFeedbackCheckboxes.forEach((otherFeedBackCheckbox) => {
		otherFeedBackCheckbox.addEventListener('click', function () {
			const otherFeedbackInput = otherFeedBackCheckbox.parentElement?.querySelector('.nps-feedback-form__other-feedback-input');
			if (otherFeedBackCheckbox.checked) {
				hasOtherFeedback = true;
				otherFeedbackInput.classList.remove('tw-hidden')
			} else {
				hasOtherFeedback = false;
				otherFeedbackInput.classList.add('tw-hidden')
			}
		})
	})

	otherFeedbackInputElList.forEach(otherFeedbackInput => {
		otherFeedbackInput.addEventListener('input', function (e) {
			otherFeedbackInput.value = e.target.value;
		})
	})

	commentTextarea.addEventListener("input", function(e){
		const currentCount = 250 - JSON.parse(e.target.value.length)
		textAreaMaxLength.textContent = ""
		textAreaMaxLength.textContent = currentCount;
	});

	wrapperEl?.classList.remove('nps-feedback-form__inner-wrapper--disabled');
});